import React, { createContext, useContext, useState, useCallback } from "react"

/** Type return values */
interface MapViewContextValue {
  view: __esri.MapView | undefined
  setView: React.Dispatch<__esri.MapView>
}

/** Generate the context */
const MapViewContext = createContext<MapViewContextValue | undefined>(undefined)

/** Provider to wrap your app with */
export const MapViewProvider: React.FC = ({ children }) => {
  /** Store the container in state */
  const [view, setView] = useState<__esri.MapView | undefined>()

  const setViewWhen = useCallback(initialisedView => {
    initialisedView
      .when()
      .then((view: __esri.MapView) => {
        view.ui.move("zoom", "bottom-right")
        setView(view)
      })
      .catch((error: Error) =>
        console.warn("An error occurred creating the map", error)
      )
  }, [])

  return (
    <MapViewContext.Provider value={{ view, setView: setViewWhen }}>
      {children}
    </MapViewContext.Provider>
  )
}

/** Hook to consume the context */
export const useMapView = () => {
  const context = useContext(MapViewContext)
  if (!context) throw Error("Not inside <MapViewProvider />")
  return context
}
